import { ScmCdnInternalDynamicDomain } from "./scmCdnDomains.nonTTP";
const I18nScmBuildVGeos = [
  "row",
  "eu"
];
const TtpScmBuildVGeos = [
  "us"
];
var SupportedScmCdnBizKeys;
(function(SupportedScmCdnBizKeys2) {
  SupportedScmCdnBizKeys2["TikTokWeb"] = "tiktok_web";
  SupportedScmCdnBizKeys2["TikTokWebsiteNeutral"] = "tiktok_website_vpcx";
  SupportedScmCdnBizKeys2["TikTokWebsiteLoginNeutral"] = "tiktok_website_login_vpcx";
  SupportedScmCdnBizKeys2["DefaultOuterCommon"] = "default_outer_common";
  SupportedScmCdnBizKeys2["DefaultInternalCommon"] = "default_internal_common";
})(SupportedScmCdnBizKeys || (SupportedScmCdnBizKeys = {}));
const SupportedScmCdnBizDomainConfigs = {
  ["tiktok_web"]: {
    onlineBuild: "outerDomain",
    testBuild: "outerDomain",
    offlineBuild: "outerDomain"
  },
  ["tiktok_website_vpcx"]: {
    onlineBuild: "outerDomain",
    testBuild: "outerDomain",
    offlineBuild: "internalDomain"
  },
  ["tiktok_website_login_vpcx"]: {
    onlineBuild: "outerDomain",
    testBuild: "outerDomain",
    offlineBuild: "internalDomain"
  },
  ["default_outer_common"]: {
    onlineBuild: "outerDomain",
    testBuild: "internalDomain",
    offlineBuild: "internalDomain"
  },
  ["default_internal_common"]: {
    onlineBuild: "internalDomain",
    testBuild: "internalDomain",
    offlineBuild: "internalDomain"
  }
};
const DefaultOuterScmCdnDomainConfig = {
  onlineBuild: "outerDomain",
  testBuild: "internalDomain",
  offlineBuild: "internalDomain"
};
const DefaultInternalScmCdnDomainConfig = {
  onlineBuild: "internalDomain",
  testBuild: "internalDomain",
  offlineBuild: "internalDomain"
};
const ScmResources = {
  i18nBuildVGeos: I18nScmBuildVGeos,
  ttpBuildVGeos: TtpScmBuildVGeos,
  internalDynamicDomain: ScmCdnInternalDynamicDomain,
  supportedDomainConfigs: SupportedScmCdnBizDomainConfigs,
  defaultOuterDomainConfig: DefaultOuterScmCdnDomainConfig,
  defaultInternalDomainConfig: DefaultInternalScmCdnDomainConfig
};
export {
  DefaultInternalScmCdnDomainConfig,
  DefaultOuterScmCdnDomainConfig,
  I18nScmBuildVGeos,
  ScmCdnInternalDynamicDomain,
  ScmResources,
  SupportedScmCdnBizDomainConfigs,
  SupportedScmCdnBizKeys,
  TtpScmBuildVGeos
};

//# sourceMappingURL=scm.js.map